__turbopack_context__.v({
  "footer": "Footer-module-scss-module__2B70wa__footer",
  "line-break": "Footer-module-scss-module__2B70wa__line-break",
  "text-align_center": "Footer-module-scss-module__2B70wa__text-align_center",
});
